





























































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { throttle } from 'lodash'
import { detect, BrowserName } from 'detect-browser'
import semver from 'semver'
import zenscroll from 'zenscroll'

import SectionIntro from './section/SectionIntro.vue'
import SectionWood from './section/SectionWood.vue'
import SectionCorian from './section/SectionCorian.vue'
import SectionCommon from './section/SectionCommon.vue'
import SectionCustomer from './section/SectionCustomer.vue'
import SectionDelivery from './section/SectionDelivery.vue'
import SectionRetailer from './section/SectionRetailer.vue'
import SectionComments from './section/SectionComments.vue'
import SectionAttachments from './section/SectionAttachments.vue'
import SectionSubmit from './section/SectionSubmit.vue'

interface Section {
  component: any,
  name: string,
  title: string,
  shortTitle?: string,
}

interface SectionElement extends Section {
  element: HTMLElement,
}

@Component({})
export default class Forms extends Vue {
  browser: null | {
    name: BrowserName | "node";
    version: string;
    os: string;
  } = null;

  currentSection: string = 'about'

  expandSidebar = false

  sections: Section[] = [
    {
      component: SectionIntro,
      name: 'about',
      title: 'Dette gjelder',
    },
    {
      component: SectionRetailer,
      name: 'retailer',
      title: 'Denne forespørselen kommer fra',
      shortTitle: 'Forhandler',
    },
    {
      component: SectionCustomer,
      name: 'customer',
      title: 'Sluttkunde - opplysninger',
      shortTitle: 'Sluttkunde',
    },
    {
      component: SectionWood,
      name: 'wood',
      title: 'Heltre',
    },
    {
      component: SectionCorian,
      name: 'corian',
      title: 'Corian®',
    },
    {
      component: SectionCommon,
      name: 'additions',
      title: 'Tillegg: Koketopp, kum, servant og øvrige tillegg',
      shortTitle: 'Tillegg',
    },
    {
      component: SectionDelivery,
      name: 'delivery',
      title: 'Levering og montering',
      shortTitle: 'Levering og mont.',
    },
    {
      component: SectionComments,
      name: 'comments',
      title: 'Ytterligere kommentarer og informasjon til forespørslen',
      shortTitle: 'Kommentarer',
    },
    {
      component: SectionAttachments,
      name: 'attachments',
      title: 'Vedlegg',
    },
    {
      component: SectionSubmit,
      name: 'submit',
      title: 'Send inn',
    },
  ]

  get siteUrl (): string {
    let url = document.location.href
    const anchorPos = url.indexOf('#');
    if (anchorPos === -1) {
      return url;
    } else {
      return url.slice(0, anchorPos);
    }
  }

  get visibleSections (): Section[] {
    return this.sections.filter(section => {
      return this.$store.getters['orderForm/show'](section.name)
    })
  }

  get sectionElements (): SectionElement[] {
    return this.visibleSections.map(section => {
      let ref = this.$refs[section.name]

      if (Array.isArray(ref)) {
        ref = ref[0]
      }

      if (ref instanceof Element) {
        return { element: ref as HTMLElement, ...section }
      } else if (ref instanceof Vue) {
        return { element: ref.$el as HTMLElement, ...section }
      } else {
        throw new Error('Could not map section to element')
      }
    })
  }

  get supportedBrowser () {
    if (this.browser) {
      if (this.browser.name === 'ie' && semver.lt(this.browser.version, '10.0.0')) {
        return false
      }
    }

    return true
  }

  get isStandalone(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches
  }

  get canPromptForInstall(): boolean {
    return this.$store.state.install.prompt !== null
  }

  show (name: string): boolean {
    return this.$store.getters['orderForm/show'](name)
  }

  // Defined in mounted()
  onScroll: () => void = () => {};
  onResize: () => void = () => {};

  promptForInstall(): void {
    this.$store.dispatch('install/prompt')
  }

  created () {
    this.browser = detect()
  }

  mounted () {
    let vm = this

    this.onResize = throttle(function () {
      vm.expandSidebar = document.body.clientWidth >= 992
    }, 100)

    this.onScroll = throttle(function () {
      const scrollPos = window.pageYOffset

      let sections = vm.sectionElements.slice()
      sections.reverse()

      for (let section of sections) {
        if (section.element.getBoundingClientRect().top < 200) {
          if (section.name !== vm.currentSection) {
            vm.currentSection = section.name
          }
          break
        }
      }
    }, 100)

    this.onResize()
    this.onScroll()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
  }

  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  }
}
